<script setup lang="ts">
import {RouterView} from 'vue-router';
import {onMounted} from 'vue';
import {getAppName, getAppVersion, getBackendUrl, getFrontendUrl} from '@/base/frontendConfig';

onMounted(()=>{
    console.info(`INFO : App Name           = ${getAppName()}`);
    console.info(`INFO : App Version        = ${getAppVersion()}`);
    console.info(`INFO : FrontendUrl        = ${getFrontendUrl()}`);
    console.info(`INFO : BackendUrl         = ${getBackendUrl()}`);
})
</script>

<template>
  <RouterView/>
</template>